import axios from 'axios';
import API_ROOT from '../constants/api';
import { getHeaders } from '../services/ApiServices';

const ROUTE = '/admin/congratulations-messages';

export const apiGetCongratulationsMessages = (token) => axios
  .get(`${API_ROOT}${ROUTE}`, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiPostCongratulationsMessage = (token, data) => axios
  .post(`${API_ROOT}${ROUTE}`, data, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiPutCongratulationsMessage = (token, id, data) => axios
  .put(`${API_ROOT}${ROUTE}/${id}`, data, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiDeleteCongratulationsMessage = (token, id) => axios
  .delete(`${API_ROOT}${ROUTE}/${id}`, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);
